<div class="flex h-screen w-full items-center justify-around">
	<div class="flex flex-col items-center justify-around gap-10">
		<div class="text-3xl text-on-background">A bientôt, {{ $client().pseudo ?? $client().nom }} !</div>
		@if ($isCare()) {
			<img
				[src]="AgatheYouCareAssets.LOGO_COMPLET"
				alt="Logo Agathe You Care"
				class="w-1/2"
			/>
		} @else {
			<img
				src="/static-assets/imgs/agathe-you/logo-agathe-you.svg"
				alt="Logo Agathe You"
				class="w-1/2"
			/>
		}
	</div>
</div>
